import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of translations.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListTranslationPage - Lazy-loaded ListTranslationPage component.
 */
const ListTranslationPage = Loadable(
  lazy(() => import("./ListTranslationPage"))
);

/**
 * Lazy-loaded component for rendering the add translation page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} AddTranslationPage - Lazy-loaded AddTranslationPage component.
 */
const AddTranslationPage = Loadable(lazy(() => import("./AddTranslationPage")));

/**
 * Lazy-loaded component for rendering the View translation page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} EditTranslationPage - Lazy-loaded EditTranslationPage component.
 */
const EditTranslationPage = Loadable(
  lazy(() => import("./EditTranslationPage"))
);

/**
 * Array containing route definitions for the translation-related pages.
 * @constant {Object[]} TranslationRoutes - Array of translation route objects.
 * @property {string} TranslationRoutes[].path - The translation of the translation route.
 * @property {React.ReactElement} TranslationRoutes[].element - The React element to be rendered for the translation route.
 */
const TranslationRoutes = [
  {
    path: "list",
    element: <ListTranslationPage />,
  },
  {
    path: "add",
    element: <AddTranslationPage />,
  },
  {
    path: "edit/:translation_id",
    element: <EditTranslationPage />,
  },
];

export default TranslationRoutes;
